// **Author:** Selvadurai
import {
  Container,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Paper,
  Snackbar,
  Alert,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";

export default function Transfer() {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [otpMethod, setOtpMethod] = useState("email");
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const handleSendOtp = () => {
    if (!selectedAccount || !amount) {
      setSnackbarMessage("Please fill in beneficiary and amount before sending OTP.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const newOtp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOtp(newOtp);
    setSnackbarMessage(`OTP sent via ${otpMethod.toUpperCase()}: ${newOtp}`);
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
  };

  const userId = "553b"; // Use your actual user id from db.json

  // Fetch beneficiaries from json-server
  const [beneficiaries, setBeneficiaries] = useState([]);
  useEffect(() => {
    fetch("http://localhost:3001/beneficiaries")
      .then((res) => res.json())
      .then(setBeneficiaries)
      .catch(() => setBeneficiaries([]));
  }, []);

  const handleTransfer = async () => {
    if (!selectedAccount || !amount || !otp) {
      setSnackbarMessage("Please fill in all fields and enter OTP before transferring.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (otp === generatedOtp) {
      const transaction = {
        transactionDate: new Date().toISOString(),
        transactionType: "DR",
        amount: Number(amount),
        remarks,
      };

      try {
        // Fetch current transactions for the user
        const resGet = await fetch(`http://localhost:3001/customers/${userId}`);
        const userData = await resGet.json();
        const currentTransactions = Array.isArray(userData.transactions) ? userData.transactions : [];

        // PATCH updated transactions array
        const resPatch = await fetch(`http://localhost:3001/customers/${userId}`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            transactions: [...currentTransactions, transaction],
          }),
        });

        if (resPatch.ok) {
          setSnackbarMessage(`₹${amount} transferred to ${selectedAccount} successfully!`);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);

          setSelectedAccount("");
          setAmount("");
          setRemarks("");
          setOtp("");
          setGeneratedOtp("");
        } else {
          throw new Error("Failed to update transaction");
        }
      } catch (err) {
        setSnackbarMessage("Server error. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } else {
      setSnackbarMessage("Invalid OTP. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Fund Transfer
        </Typography>

        <TextField
          select
          fullWidth
          label="Transfer Fund To"
          margin="normal"
          value={selectedAccount}
          onChange={(e) => setSelectedAccount(e.target.value)}
        >
          {beneficiaries.map((b, i) => (
            <MenuItem key={i} value={b.accountNumber}>
              {b.name} ({b.accountNumber})
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          label="Amount"
          type="number"
          margin="normal"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        <TextField
          fullWidth
          label="Remarks"
          margin="normal"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1">Send OTP through</Typography>
          <RadioGroup row value={otpMethod} onChange={(e) => setOtpMethod(e.target.value)}>
            <FormControlLabel value="sms" control={<Radio />} label="SMS" />
            <FormControlLabel value="email" control={<Radio />} label="Email" />
          </RadioGroup>
        </Box>

        <Button variant="outlined" fullWidth sx={{ mt: 2 }} onClick={handleSendOtp}>
          Send OTP
        </Button>

        <TextField fullWidth label="Enter OTP" margin="normal" value={otp} onChange={(e) => setOtp(e.target.value)} />

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button variant="contained" color="primary" onClick={handleTransfer}>
            Transfer Fund
          </Button>
          <Button variant="outlined" color="secondary" onClick={() => window.location.reload()}>
            Cancel
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // This moves it to the top
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}
